(() => {
  const STORAGE_KEY = 'ota_recently_viewed_products';
  const LIMIT = 12;

  function safeParse(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function getItems() {
    const parsed = safeParse(localStorage.getItem(STORAGE_KEY), []);
    return Array.isArray(parsed) ? parsed : [];
  }

  function saveItems(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function normalizeProduct(product) {
    if (!product || !product.handle || !product.title || !product.url) return null;

    return {
      handle: String(product.handle),
      title: String(product.title),
      url: String(product.url),
      image: product.image ? String(product.image) : '',
      price: product.price ? String(product.price) : ''
    };
  }

  function addCurrentProduct() {
    const current = normalizeProduct(window.otaCurrentProduct);
    if (!current) return;

    let items = getItems();
    items = items.filter(item => item.handle !== current.handle);
    items.unshift(current);

    if (items.length > LIMIT) {
      items = items.slice(0, LIMIT);
    }

    saveItems(items);
  }

  function renderRecentlyViewed() {
    const section = document.getElementById('otaRecentlyViewedSection');
    const list = document.getElementById('otaRecentlyViewedList');
    if (!section || !list) return;

    const currentHandle = window.otaCurrentProduct?.handle;
    const items = getItems().filter(item => item.handle !== currentHandle);

    if (!items.length) return;

    const html = items.map(item => {
      const imageHtml = item.image
        ? `<img src="${item.image}" alt="${escapeHtml(item.title)}" loading="lazy">`
        : `<div class="ota-rv-noimage">No image</div>`;

      return `
        <li class="ota-recently-viewed-item">
          <a href="${item.url}" class="ota-recently-viewed-link">
            <div class="ota-recently-viewed-image">
              ${imageHtml}
            </div>
            <h3 class="ota-recently-viewed-title">${escapeHtml(item.title)}</h3>
            <span class="ota-recently-viewed-price">${escapeHtml(item.price)}</span>
          </a>
        </li>
      `;
    }).join('');

    list.innerHTML = html;
    section.hidden = false;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (window.otaCurrentProduct) {
      addCurrentProduct();
    }
    renderRecentlyViewed();
  });
})();